import React, { useState, useEffect } from 'react';
import client from '../api/client';
import { Card, Spin, Empty, Pagination, message } from 'antd';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';
import styles from './Blog.module.css';

const API_BASE = '/blog';

export default function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    loadBlogs();
  }, [page]);

  const loadBlogs = async () => {
    setLoading(true);
    try {
      const res = await client.get(`${API_BASE}/published`, {
        params: { page, limit }
      });
      setBlogs(res.data.blogs || []);
      setTotal(res.data.total || 0);
    } catch (err) {
      message.error('خطا در بارگذاری مقالات');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SiteNav />
      <div className={styles.blogList}>
        <h2>وبلاگ هاگوارتز</h2>
      <Spin spinning={loading}>
        {blogs.length === 0 ? (
          <Empty description="هنوز مقاله‌ای منتشر نشده است. جغدها در راه‌اند..." />
        ) : (
          <>
            <div className={styles.articles}>
              {blogs.map((blog) => (
                <Card
                  key={blog._id}
                  className={styles.articleCard}
                  hoverable
                >
                  <h3 className={styles.articleTitle}>{blog.title}</h3>
                  <p className={styles.articleMeta}>
                    نویسنده: <strong>{blog.author?.firstName} {blog.author?.lastName}</strong>
                  </p>
                  <p className={styles.articleMeta}>
                    تاریخ: {new Date(blog.publishedAt).toLocaleDateString('fa-IR')}
                  </p>
                  <p className={styles.articlePreview}>
                    {blog.content.substring(0, 200)}...
                  </p>
                  <a href={`/blog/${blog._id}`} className={styles.readMore}>
                    ادامه مطلب
                  </a>
                </Card>
              ))}
            </div>
            <Pagination
              current={page}
              total={total}
              pageSize={limit}
              onChange={setPage}
              className={styles.pagination}
            />
          </>
        )}
      </Spin>
      </div>
      <SiteFooter />
    </>
  );
}
